module.exports = __webpack_public_path__ + "media/icons/caret-84e6d85d.svg";